import React, { useEffect, useState, useCallback } from 'react';
import { DefaultContainer } from '../../../../components/template/Main';
import { DocumentoHeader } from './DocumentoHeader';
import { Grupo } from '../Grupo';
import { useParams } from 'react-router-dom';
import { LoadGroups } from '../utils/Documento';
import { DataCadastroProvider } from '../../../../contexts/DataCadastroContext';


export const Documento = () => {
  
  const { documentoId } = useParams();
  const [grupos, setGrupos] = useState([]);
  const [ocultarProdutosServicos, setOcultarProdutosServicos] = useState(true);

  const refreshDocumentoGrupo = useCallback(async () => {
    try {
      const groups = await LoadGroups(documentoId);
      setGrupos(groups);
    } catch (error) {
      console.error('Erro ao carregar grupos:', error);
    }
  }, [documentoId]);

  useEffect(() => {
    if (documentoId) {
      refreshDocumentoGrupo();
    }
  }, [documentoId, refreshDocumentoGrupo]);


  // console.log(grupos.length)

  return (
    
    <DataCadastroProvider>
      <DefaultContainer title="Documento">
        <DocumentoHeader
          grupos={grupos}
          refreshDocumentoGrupo={refreshDocumentoGrupo}
          ocultarProdutosServicos={ocultarProdutosServicos}
          setOcultarProdutosServicos={setOcultarProdutosServicos}
        />
        {grupos.map((grupo, index) => (
          <Grupo
            key={grupo.id}
            groupsLength={grupos.length}
            index={grupos.length - 1 - index} // índice invertido
            initialExpanded={index < 2} // os 3 primeiros da lista invertida vêm expandidos

            
            documentoId={documentoId}
            grupoId={grupo.id}
            refreshDocumentoGrupo={refreshDocumentoGrupo}
            ocultarProdutosServicos={ocultarProdutosServicos}
          />
        ))}
      </DefaultContainer>
    </DataCadastroProvider>
  );
};
